import React from "react";
import Devicelevel from "../pages/Admin/DeviceDetail/DeviceDetail/DeviceLevel";
import parseNumber from "../../utils/parseCalculate";

export default function DoSensorReadings({ data, id, reportlink }) {
  return <Devicelevel
    id={id}
    reportlink={reportlink}
    deviceDetail={{
      flow: parseNumber(data?.dissolved_oxygen),
      unit: "mg/L",
      totalFlow: parseNumber(data?.temp),
      totalUnit: "\u00B0C",
      networkStatus: data?.network_active,
      battery: data?.battery,
      deviceType: "do_sensor",
    }}
  />;
}
